import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type NotificationMode = 'silent' | 'blink' | 'full';
export const notificationModes: NotificationMode[] = ['silent', 'blink', 'full'];

interface Preferences {
  accounts: Record<string, NotificationMode>;
  setMode: (account: string, mode: NotificationMode) => void;
}

// Presentation preferences are personal and persist on this browser, including
// after logout. They never disable collection or mark notifications as read.
export const useNotificationPreferencesStore = create<Preferences>()(persist(
  (set) => ({
    accounts: {},
    setMode: (account, mode) => {
      if (!account || !notificationModes.includes(mode)) return;
      set(state => ({ accounts: { ...state.accounts, [account]: mode } }));
    },
  }),
  { name: 'agency-notification-preferences' },
));

export function notificationPresentation(mode: NotificationMode | undefined) {
  return { popups: !mode || mode === 'full', blink: mode !== 'silent' };
}
